import React from 'react';
import { MapPinIcon, PhoneIcon, NavigationIcon, MessagesSquareIcon } from 'lucide-react';
import { business, hours } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
export function LocationContact() {
  const {
    t
  } = useLanguage();
  const todayIndex = (new Date().getDay() + 6) % 7;
  return <section id="ubicacion" className="w-full bg-ink py-20 lg:py-28" data-id="element-232" data-mp="13i8ytm06qpoo">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-233" data-mp="5wlazphspfor">
        <div className="max-w-2xl" data-id="element-234" data-mp="5y65jf440ymm">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-235" data-mp="aud4gny399v2">{t.location.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-236" data-mp="ftpzvx30zp99">
            {t.location.title}
          </h2>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.25fr_0.75fr]" data-id="element-237" data-mp="1r9elol4jmi8h">
          <div className="overflow-hidden rounded-sm border border-white/10" data-id="element-238" data-mp="1rb90dhp81e44">
            <iframe title={t.location.mapTitle} src={business.mapsEmbed} className="h-[340px] w-full border-0 sm:h-[440px] lg:h-full lg:min-h-[460px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-239" data-mp="1w6obw2zraxxd" />
          </div>

          <div className="flex flex-col gap-4" data-id="element-240" data-mp="10ty9g9syuunj">
            <div className="rounded-sm border border-gold/25 bg-panel p-6" data-id="element-241" data-mp="10t6i5b6ejj32">
              <div className="flex items-start gap-3" data-id="element-242" data-mp="vv4v6f5uuzmb">
                <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-243" data-mp="vwptmfvaj2pg" />
                <address className="not-italic" data-id="element-244" data-mp="r223ydojw29a">
                  <span className="block font-display text-xl uppercase tracking-wide text-cream" data-id="element-245" data-mp="m4a7d6cynryr">
                    {business.addressShort}
                  </span>
                  <span className="block text-cream/70" data-id="element-246" data-mp="d4doxmh5zpc5">{business.city}</span>
                </address>
              </div>
              <a href={business.mapsDirections} target="_blank" rel="noreferrer noopener" className="mt-5 flex items-center justify-center gap-2 rounded-sm border border-gold/40 px-5 py-3 font-display text-sm font-semibold uppercase tracking-wider text-gold transition-colors duration-150 ease-out hover:bg-gold hover:text-ink" data-id="element-247" data-mp="850tidc899xy">
                <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="3pp10dhx7ctd8" />
                {t.location.directions}
              </a>
              <a href={business.phoneHref} className="mt-3 flex items-center justify-center gap-2 rounded-sm bg-gold px-5 py-3 font-display text-sm font-semibold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-249" data-mp="h8y408bjir47">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="cfms3srvfk5f" />
                {business.phoneDisplay}
              </a>
            </div>

            <div className="rounded-sm border border-white/10 bg-panel p-6" data-id="element-251" data-mp="14yabn3r7yr4e">
              <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-cream" data-id="element-252" data-mp="2po5znuyhwqu5">
                {t.location.hoursTitle}
              </h3>
              <ul className="mt-4 divide-y divide-white/5 text-sm" data-id="element-253" data-mp="2kojl9i6xl4jr">
                {hours.map((entry, index) => <li key={t.location.days[index]} className={`flex items-center justify-between py-2.5 ${index === todayIndex ? 'text-gold' : 'text-cream/70'}`} data-id="element-254" data-mp="2zg1wz3srccxb" data-mpi={index}>
                    <span className="font-medium" data-id="element-255" data-mp="21riepsxqawdp">
                      {t.location.days[index]}
                      {index === todayIndex && <span className="ml-2 text-[10px] uppercase tracking-widest" data-id="element-256" data-mp="2boedv81qm65l">
                          {t.location.today}
                        </span>}
                    </span>
                    <span className={entry.closed ? 'text-cream/40' : undefined} data-id="element-257" data-mp="3n3tkl3jr0cdw">
                      {entry.closed ? t.location.closed : entry.time}
                    </span>
                  </li>)}
              </ul>
            </div>

            <p className="flex items-center gap-3 rounded-sm border border-white/10 bg-panel px-6 py-4 text-sm text-cream/75" data-id="element-258" data-mp="qafnx9os8t4i">
              <MessagesSquareIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-259" data-mp="vbd4xiy23h4f" />
              {t.location.languageNote}
            </p>
          </div>
        </div>
      </div>
    </section>;
}